import { Route, createPageRoute, AppId } from '@lumapps/router';

export const PROVISIONING_DASHBOARD_ROUTE = 'provider-settings/provisioning-dashboard';

export const provisioningDashboardRoute: Route = createPageRoute({
    slug: PROVISIONING_DASHBOARD_ROUTE,
    appId: AppId.backOffice,
});
